export const TOKEN_FIELD = 'token'
export const CURRENT_LANGUAGE_FIELD = 'current-language'

export const COUNTDOWN = 30000
export const REPLY_TO_ADDRESS_KEY = 'reply-to-address'

export const STATISTICS_END_DATE = 'statistics-end-date'
export const STATISTICS_START_DATE = 'statistics-start-date'


